import ErrorController from './errorController';
import HeaderViewModel from '../viewModels/headerViewModel';

// Class containing methods for all page events
class EventController {
    constructor(ErrorController) {

    }

    /**
     * Pass in event that should be removed from the page
     * @param {object} event
     * @param {object} viewModel
     * @param {string} evt
     */
    removeEvents(event, viewModel, evt) {
        jQuery(event.element).off(event.type, function() {
            this.eventFired(event.actions);
        });
    }

    removeAllEvents(viewModel) {
        const objLength = Object.keys(viewModel.events).length;
        let i = 0;
        return new Promise(function(resolve, reject) {
            for (let evt in viewModel.events) {
                const event = viewModel.events[evt];
                jQuery(event.element).off();
                if (i === objLength - 1) {
                    resolve(viewModel);
                }
                i++;
            }
        });
    }

    /**
     * Set event as rendered (allows app to know which events have been added to the page)
     */
    eventRendered(event, viewModel, evt) {
        viewModel.setEventAsRendered(event, evt);
    }

    /**
     * Pass in event that should be removed from the page
     * @param {object} event
     * @param {object} viewModel
     * @param {string} evt
     */
    eventRemoved(event, viewModel, evt) {
        jQuery(event.element).off(event.type, function() {
            this.eventFired(event.actions);
        });
        viewModel.setEventAsRendered(event, evt);
    }

    /**
     * Loop through viewModel and attach events to page if status is true and rendered is false
     * @param {object} viewModel
     * @param {object} controller
     * @param {object} model
     * @param {string} session
     */
    attachEvents(viewModel, controller, model, session, store) {
        // attach event listeners
        const _this = this;
        this.removeAllEvents(viewModel);
        return new Promise((resolve, reject) => {
            for (let evt in viewModel.get('events')) {
                const event = viewModel.get('events')[evt];

                if (event.status === true) {
                    jQuery(document).ready(function() {
                        jQuery(event.element).on(event.type, function(e) {
                            e.preventDefault();
                            _this.eventFired(
                                event.action,
                                viewModel,
                                controller,
                                model,
                                jQuery(this),
                                session,
                                evt,
                                typeof event.sequentialModelUpdate != 'undefined' ? event.sequentialModelUpdate : false,
                                typeof event.resetTemps != 'undefined' ? event.resetTemps : true,
                                store
                            );
                        });
                    });
                }
            }

            resolve('attached');
        });
    }

    /**
     * On event being fired, run through promise chain of all updates associated with event in the viewModel
     * @param {object} viewStates
     * @param {object} events
     * @param {object} extraFunctions
     * @param {object} modelUpdate
     * @param {object} viewModel
     * @param {object} controller
     * @param {object} model
     * @param {string} selector
     * @param {string} session
     */

    eventFired({
        viewStates,
        events,
        extraFunctions,
        modelUpdate
    }, viewModel, controller, model, selector, session, evt, sequential, resetTemps, store) {
        // update model then re-render
        model.resetTemps(model, selector, '', session, '', viewModel, resetTemps)
            .then(vm => {
                return this.extraFunctionsPromiseAll(extraFunctions, viewModel, selector, model, session, store);
            })
            .then(vm => {
                if (sequential) {
                    return this.sequentialModelUpdate(modelUpdate, model, selector, session, viewModel, vm);
                } else {
                    let promiseAllArray = [];
                    modelUpdate.forEach((modelToUpdate) => {
                        if (modelToUpdate.status) {
                            promiseAllArray.push(this.modelUpdateUpdate(modelToUpdate, model, selector, session, viewModel, vm));
                        }
                    });
                    return Promise.all(promiseAllArray);
                }
            })
            .then(vm => {
                return this.removeAllEvents(viewModel);
            })
            .then(vm => {
                return this.viewStatesUpdate(viewStates, viewModel);
            })
            .then(vm => {
                return this.eventUpdate(events, viewModel);
            })
            .then(vm => {
                // prevent double rendering bug on routeToLink
                if (_.includes(extraFunctions, 'routeToLink')) {
                    return;
                } else {
                    return controller.render(store);
                }
            })
            .catch(error => {
                console.log('event fired');
                console.log(error);
                if (error.type === 'serviceError') {
                    ErrorController.handleErrors(error, model, viewModel, controller, this, selector, evt, store);
                } else if (error.type === 'qasFail' || error.type === 'altWorkflow' || error.type === 'validationError') {
                    this.removeAllEvents(viewModel)
                        .then(vm => {
                            controller.render(store);
                        })
                        .catch(error => {
                            console.log("This should never happen");
                        });
                }
            });
    }

    /**
     * Update the status of viewStates associated with fired event
     * @param {object} viewStates
     * @param {object} viewModel
     */
    viewStatesUpdate(viewStates, viewModel) {
        const vsLength = viewStates.names.length;
        return new Promise(function(resolve, reject) {
            if (vsLength > 0) {
                viewStates.names.forEach(function(viewStateName, index) {
                    if (viewStates.values[index] !== undefined) {
                        viewModel.set('viewStates', viewStateName, viewStates.values[index]);
                    } else {
                        viewModel.set('viewStates', viewStateName);
                    }
                    if (index === vsLength - 1) {
                        resolve(viewModel);
                    }
                });
            } else {
                resolve(viewModel);
            }
        });
    }

    /**
     * Update the status of events associated with fired event
     * @param {object} events
     * @param {object} viewModel
     */
    eventUpdate(events, viewModel) {
        const eLength = events.names.length;
        return new Promise(function(resolve, reject) {
            if (eLength > 0) {
                events.names.forEach(function(eventName, index) {
                    if (events.values[index] !== undefined) {
                        viewModel.set('events', eventName, events.values[index]);
                    } else {
                        viewModel.set('events', eventName);
                    }

                    if (index === eLength - 1) {
                        resolve(viewModel);
                    }
                });
            } else {
                resolve(viewModel);
            }
        });
    }

    /**
     * Run extraFunctions associated with fired event
     * @param {object} extraFunctions
     * @param {object} viewModel
     */
    extraFunctionsPromiseAll(extraFunctions, viewModel, selector, model, session, store) {
        return new Promise((resolve, reject) => {
            extraFunctions.reduce((promise, item) => {
                return promise.then((result) => {
                    return this.extraFunctionsUpdate(item, selector, viewModel, model, session, store);
                });

            }, Promise.resolve(true))
            .then(promise => {
                return resolve(true);
            })
            .catch(error => {
                return reject(error);
            });
        })
    }

    extraFunctionsUpdate(efName, selector, viewModel, model, session, store) {
        return viewModel[efName](selector, model, session, store);
    }

    /**
     * Update model properties associated with fired event
     * @param {object} modelUpdate
     * @param {object} model
     * @param {string} selector
     * @param {string} session
     * @param {object} viewModel
     */
    modelUpdateUpdate(modelUpdate, model, selector, session, viewModel, makeServiceCall) {
        let serviceMethod;

        if (typeof modelUpdate.serviceMethod === 'array' || typeof modelUpdate.serviceMethod === 'object') {
            serviceMethod = model.initialized[modelUpdate.modelProperty].postNeeded ? modelUpdate.serviceMethod[0] : modelUpdate.serviceMethod[1];
        } else {
            serviceMethod = modelUpdate.serviceMethod;
        }
        if (modelUpdate.status && modelUpdate.altModel !== "") {
            return modelUpdate.altModel[modelUpdate.modelMethod](modelUpdate.altModel, selector, modelUpdate.modelProperty, session, serviceMethod, viewModel, model, makeServiceCall);
        } else if (modelUpdate.status) {
            return model[modelUpdate.modelMethod](model, selector, modelUpdate.modelProperty, session, serviceMethod, viewModel, makeServiceCall);

        }
    }

    sequentialModelUpdate(modelUpdate, model, selector, session, viewModel, makeServiceCall) {
        return new Promise(function(resolve, reject) {
            let serviceMethod;
            let results = [];
            modelUpdate.reduce((promise, mu) => {
                return promise.then((result) => {
                    results.push(result);

                    if (typeof mu.serviceMethod === 'array' || typeof mu.serviceMethod === 'object') {
                        serviceMethod = model.initialized[mu.modelProperty].postNeeded ? mu.serviceMethod[0] : mu.serviceMethod[1];
                    } else {
                        serviceMethod = mu.serviceMethod;
                    }

                    if (mu.status && mu.altModel !== "") {
                        return mu.altModel[mu.modelMethod](mu.altModel, selector, mu.modelProperty, session, serviceMethod, viewModel, model, makeServiceCall, results);
                    } else if (mu.status) {
                        return model[mu.modelMethod](model, selector, mu.modelProperty, session, serviceMethod, viewModel, makeServiceCall, results);
                    }

                });
            }, Promise.resolve(true))
            .then((promise) => {
                return resolve(true);
            })
            .catch(error => {
                return reject(error);
            });
        });
    }
}

const event = new EventController(ErrorController);

export default event;
